import reactComponentLoader from 'scripts/react-component-loader'

import { Affiliates } from '../Affiliates'

reactComponentLoader(Affiliates, '[data-affiliates-landing-page]')
